module.exports = __webpack_public_path__ + "static/media/best bike transport from hyderabad.80c662a3.jpg";